/* eslint-disable sort-keys */
export default {
  light: {
    "autocomplete-close-button-border-focus": "rgba(17,27,64,0.2)",
    "autocomplete-disabled": "neutral-700",
    "autocomplete-index-button": "primary-500",
    "autocomplete-invalid-text": "primary-100",
    "autocomplete-letter-separator": "neutral-500",
    "autocomplete-option-hover": "neutral-800",
    "autocomplete-section-label": "neutral-400",
    "autocomplete-separator": "neutral-500",
    "confirmation-number-text": "success-500",
    "flight-confirmation-card-confirmation-label": "neutral-200",
    "flight-count": "primary-500",
    "flight-count-font-size": "0.8125rem",
    "flight-indicator-disabled": "neutral-200",
    "flightStopsTracker-caption": "neutral-200",
    "flightStopsTracker-label": "neutral-200",
    "flightStopsTracker-label-background": "neutral-900",
    "flightStopsTracker-separator-color": "primary-700",
    "flightStopsTracker-separator-color-nonstop": "neutral-200",
    "itinerary-badge-emphasis": "primary-200",
    "itinerary-badge-font-large": "1.25rem",
    "itinerary-badge-font-medium": "1.125rem",
    "itinerary-badge-font-small": "0.75rem",
    "itinerary-badge-font-xlarge": "1.5rem",
    "itinerary-badge-font-xsmall": "0.625rem",
    "itinerary-badge-normal": "neutral-200",
    "itinerary-badge-subtle": "neutral-200",
    "itinerary-flight-airline-operator-text": "neutral-300",
    "itinerary-flight-duration-primary": "neutral-100",
    "itinerary-flight-duration-secondary": "primary-500",
    "itinerary-flight-invalid": "neutral-200",
    "itinerary-recent-search-itinerary-dates": "neutral-300",
    "itinerary-stations-disabled": "neutral-300",
    "itinerary-stations-primary": "primary-500",
    "itinerary-stations-secondary": "primary-100",
    "next-day-indicator": "success-500",
    "overnight-indicator": "tertiary-500",
    "primary-badge-active-text": "primary-100",
    "primary-badge-background": "secondary-500",
    "primary-badge-disabled": "neutral-200",
    "primary-badge-disabled-text": "neutral-900",
    "stop-duration-change-planes": "neutral-300",
    "stop-duration-line": "neutral-300",
    "vacations-destination-description": "neutral-200",
  },
  dark: {},
};
